import { render, staticRenderFns } from "./JurisdictionalDriver.vue?vue&type=template&id=be6b3f5c&scoped=true&"
import script from "./JurisdictionalDriver.vue?vue&type=script&lang=js&"
export * from "./JurisdictionalDriver.vue?vue&type=script&lang=js&"
import style0 from "./JurisdictionalDriver.vue?vue&type=style&index=0&id=be6b3f5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6b3f5c",
  null
  
)

export default component.exports